// const Web = () => {
//   return <h1>Web & Mobile App Development</h1>;
// };

// export default Web;
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import H2 from "../../../components/typography/h2";
import OurClients from "../../../components/clients";

import Styles from "./styles.module.scss";
import styles from "./styles.module.scss";

// Image assets
import wifi from "../../../assets/img/wifiicon.png";
import case_studies from "../../../assets/img/case_studiesicon.png";
import amberaroma from "../../../assets/img/amberaroma.png";
import hostec from "../../../assets/img/hostec.png";
import oncloudwifi from "../../../assets/img/oncloudwifi.png";
import sentabook from "../../../assets/img/sentabook.png";
import project369view from "../../../assets/img/360view.png";
import uniwell from "../../../assets/img/uniwell.png";
import zeeqr from "../../../assets/img/zeeqrbg.png";

import programmingimg1 from "../../../assets/img/programmingimg1.png";
import programmingimg2 from "../../../assets/img/programmingimg2.png";
import programmingimg3 from "../../../assets/img/programmingimg3.png";
import programmingimg4 from "../../../assets/img/programmingimg4.png";
import programmingimg5 from "../../../assets/img/programmingimg5.png";
import programmingimg6 from "../../../assets/img/programmingimg6.png";
import programmingimg7 from "../../../assets/img/programmingimg7.png";
import programmingimg8 from "../../../assets/img/programmingimg8.png";
import programmingimg9 from "../../../assets/img/programmingimg9.png";
import programmingimg10 from "../../../assets/img/programmingimg10.png";
import programmingimg11 from "../../../assets/img/programmingimg11.png";
import programmingimg12 from "../../../assets/img/programmingimg12.png";
import programmingimg13 from "../../../assets/img/programmingimg14.png";
import programmingimg14 from "../../../assets/img/programmingimg15.png";
import programmingimg15 from "../../../assets/img/programmingimg16.png";
import programmingimg16 from "../../../assets/img/programmingimg17.png";

import { ButtonComponent } from "@syncfusion/ej2-react-buttons";

// Case study images
import KumarPhotography from "../../../assets/casestudy/KumarPhotoGraphy.webp";
import AGTech from "../../../assets/casestudy/A.G. Tech Industries.webp";
import GenuineItSystem from "../../../assets/casestudy/Genuine IT Systems.webp";
import Gnanodaya from "../../../assets/casestudy/Gnanodhaya VLSI Technologies.webp";
import Asset from "../../../assets/casestudy/assetglanceprojectimg.webp";
import Hostec from "../../../assets/casestudy/Hosteccasestudy.webp";
import Amber from "../../../assets/casestudy/Amber Aroma.webp";
import Devangi1stimg from "../../../assets/casestudy/Devangi1stimg.webp";
import ZEEQR from "../../../assets/casestudy/ZEEQRCaseStudy.webp";
import ScentaBook from "../../../assets/casestudy/scentabookcasestudy.webp";
import KudlaBuilders from "../../../assets/casestudy/kudlabuilders.png";
import AryaFireAndSafety from "../../../assets/casestudy/aryafireandsafety.png";
import HilightLightingStudio from "../../../assets/casestudy/hilightlightingstudio.png";
import ScienceBlue from "../../../assets/casestudy/scienceblue.png";
import SNKollajeJewellers from "../../../assets/casestudy/snkollajejewellers.png";
import BuildALead from "../../../assets/casestudy/buildalead.png";
import RaajPowerElectricals from "../../../assets/casestudy/raajpowerelectricals.png";

function WebAndMobileApplication() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const navigate = useNavigate();


  interface ShowcaseItem {
    image: string;
    category: string;
    title: string;
    link?: string;
    website?: string;
  }
  const showcaseItems: ShowcaseItem[] = [
    {
      image: KumarPhotography,
      category: "Website Design",
      title: "Kumar’s Photo",
      link: "/kumarphotography",
    },
    {
      image: AGTech,
      category: "Website Design",
      title: "A.G. Tech Industries",
      link: "/ajtechIndustry",
      website: "https://agtechindustries.com/",
    },
    {
      image: GenuineItSystem,
      category: "Website Design",
      title: "Genuine IT Systems",
      link: "/genuineitsystems",
      website: "https://www.genitsgroup.com/",
    },
    {
      image: Gnanodaya,
      category: "Website Design",
      title: "Gnanodhaya VLSI Technologies",
      link: "/gnanodhaya",
      website: "https://gnanodayavlsi.com/",
    },
    {
      image: Asset,
      category: "Website Design",
      title: "Asset Glance",
      link: "/assetglance",
      website: "https://assetglance.com/",
    },
    {
      image: Hostec,
      category: "Website Design",
      title: "Hostec",
      link: "/hostec",
      website: "https://hostec.com/",
    },
    {
      image: Amber,
      category: "Website Design",
      title: "Amber Aroma",
      link: "/amber-aroma",
      website: "https://amberaroma.com/",
    },
    {
      image: ZEEQR,
      category: "Website Design",
      title: "ZEEQR",
      link: "/zeeqr",
      website: "https://zeeqr.com/",
    },
    {
      image: Devangi1stimg,
      category: "Website Design",
      title: "Devangi Atithya",
      link: "/devangiAtithya",
      website: "https://devangiatithya.com/",
    },

    {
      image: ScentaBook,
      category: "Website Design",
      title: "Scenta Book",
      link: "/scenta-book",
      website: "https://scentabook.com/",
    },
    {
      image: KudlaBuilders,
      category: "Website Design",
      title: "Kudla Builders",
      link: "/kudla-builders",
      website: "https://kudlabuilders.com/",
    },
    {
      image: AryaFireAndSafety,
      category: "Website Design",
      title: "Arya Fire And Safety",
      link: "/aryafire-and-safety",
      website: "https://aryafireandsafety.com/",
    },
    {
      image: HilightLightingStudio,
      category: "Website Design",
      title: "Hilight Lighting Studio",
      link: "/hilight-lighting-studio",
      // website: "#/", //this is not original website url
    },
    {
      image: ScienceBlue,
      category: "Website Design",
      title: "Science Blue",
      link: "/science-blue",
      website: "https://scienceblue.co.in/", //this is not original website url
    },
    {
      image: SNKollajeJewellers,
      category: "Website Design",
      title: "S.N Kollaje Jewellers",
      link: "/sn-kollaje-jewellers",
      website: "http://www.snkollajejewellers.com/",
    },
    {
      image: BuildALead,
      category: "Website Design",
      title: "Build A Lead",
      link: "/build-a-lead",
      website: "https://darkblue-grouse-908073.hostingersite.com/", // //this is not original website url
    },
    {
      image: RaajPowerElectricals,
      category: "Website Design",
      title: "Raaj Power Electricals",
      link: "/raaj-power-electricals",
      // website: "#/", // //this is not original website url
    },
  ];

  return (
    <section>
      <div className="container">
        <p className="page_info_head">Projects</p>
        <div className={Styles.project_info}>
          <H2>
            <span>Explore a rich collection of </span>{" "}
            <span>innovative projects.</span>{" "}
            <span> Unlock Your Online Potential: </span>
            <span>Elevate Your Success with a </span>
            <span>High-Performing Website.</span>
          </H2>
          <p>
            Elevate Your Online Presence: Let Our Proven Visual Platform Models
            Make Your Next Project a Stunning Success.
          </p>
        </div>
        {/* <div className={Styles.Project_img}>
                    <img className={Styles.projectimglink} src={sentabook} />
                </div>
                <div className={Styles.website_details}>

                    <div className={Styles.website_img}>
                        <a href="https://scentabook.com/" target="_blank">
                            <img src={wifi} />
                            <p>Live website</p>
                        </a>
                    </div>
                    <div className={Styles.website_img}>
                        <img src={case_studies}></img>
                        <p>Case Studies</p>
                    </div>
                </div> */}
        <div className={styles.grid}>
          {showcaseItems.map((item, index) => (
            <div key={index} className={styles.card}>
              {item.link ? (
                <>
                  <div className={styles.imageContainer}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className={styles.image}
                    />
                    <div className={styles.hoverOverlay}>
                    {/* Live Website */}
                    {item.website && (
                      <div
                        className={styles.link}
                        role="button"
                        tabIndex={0}
                        onClick={() => window.open(item.website, "_blank")}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            window.open(item.website, "_blank");
                          }
                        }}
                      >
                        <div className={styles.icon}>
                          <img src={wifi} alt="Live Website" />
                          <p>Live Website</p>
                        </div>
                      </div>
                    )}

                    {/* Case Studies */}
                    <div
                      className={styles.link}
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        if (item.link) {
                          window.scrollTo(0, 0);
                          navigate(item.link);
                        }
                      }}

                      onKeyDown={(e) => {
                        if (e.key === "Enter" && item.link) {
                          window.scrollTo(0, 0);
                          navigate(item.link);
                        }
                      }}

                    >
                      <div className={styles.icon}>
                        <img src={case_studies} alt="Case Studies" />
                        <p>Case Studies</p>
                      </div>
                    </div>
                  </div>

                  </div>
                  <p className={styles.category}>{item.category}</p>
                  <h3 className={styles.title}>
                    <Link
                      to={item.link || "#"}
                      className={styles.titleLink}
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      {item.title}
                    </Link>
                  </h3>
                </>
              ) : (
                <>
                  <div className={styles.imageContainer}>
                    <img
                      src={item.image}
                      alt={item.title}
                      className={styles.image}
                    />
                    <div className={styles.hoverOverlay}>
                      <div className={styles.icon}>
                        <img src={wifi} alt="Live Website" />
                        <p>Live Website</p>
                      </div>
                      <div className={styles.icon}>
                        <img src={case_studies} alt="Case Studies" />
                        <p>Case Studies</p>
                      </div>
                    </div>
                  </div>
                  <p className={styles.category}>{item.category}</p>
                  <h3 className={styles.title}>{item.title}</h3>
                </>
              )}
            </div>
          ))}
        </div>

        {/* <div className={Styles.Project_img}>
                    <img className={Styles.projectimglink} src={project369view} />
                </div>
                <div className={Styles.website_details}>

                    <div className={Styles.website_img}>
                        <a href="https://360view.ai/" target="_blank">
                            <img src={wifi} />
                            <p>Live website</p>
                        </a>
                    </div>
                    <div className={Styles.website_img}>
                        <img src={case_studies}></img>
                        <p>Case Studies</p>
                    </div>
                </div>
                <div className={Styles.Project_img}>
                    <img className={Styles.projectimglink} src={zeeqr} />
                </div>
                <div className={Styles.website_details}>
                    <div className={Styles.website_img}>
                        <a href="https://zeeqr.com/" target="_blank">
                            <img src={wifi} />
                            <p>Live website</p>
                        </a>
                    </div>
                    <div className={Styles.website_img}>
                        <img src={case_studies}></img>
                        <p>Case Studies</p>
                    </div>
                </div>
                <div className={Styles.Project_img}>
                    <img src={hostec} />
                </div>
                <div className={Styles.website_details}>

                    <div className={Styles.website_img}>
                        <a href="https://hostec.ae/" target="_blank">
                            <img src={wifi} />
                            <p>Live website</p>
                        </a>
                    </div>
                    <div className={Styles.website_img}>
                        <img src={case_studies}></img>
                        <p>Case Studies</p>
                    </div>
                </div>
                <div className={Styles.Project_img}>
                    <img src={amberaroma} />
                </div>
                <div className={Styles.website_details}>
                    <div className={Styles.website_img}>
                        <a href="https://amberaroma.com/" target="_blank">
                            <img src={wifi} />
                            <p>Live website</p>
                        </a>
                    </div>
                    <div className={Styles.website_img}>
                        <img src={case_studies}></img>
                        <p>Case Studies</p>
                    </div>
                </div>
               
           
                <div className={Styles.Project_img}>
                    <img src={oncloudwifi} />
                </div>
                <div className={Styles.website_details}>

                    <div className={Styles.website_img}>
                        <a href="https://oncloudwifi.com/" target="_blank">
                            <img src={wifi} />
                            <p>Live website</p>
                        </a>
                    </div>
                    <div className={Styles.website_img}>
                        <img src={case_studies}></img>
                        <p>Case Studies</p>
                    </div>
                </div>
                <div className={Styles.Project_img}>
                    <img className={Styles.projectimglink} src={uniwell} />
                </div>
                <div className={Styles.website_details}>

                    <div className={Styles.website_img}>
                        <a href="https://uniwell.ae/" target="_blank">
                            <img src={wifi} />
                            <p>Live website</p>
                        </a>
                    </div>
                    <div className={Styles.website_img}>
                        <img src={case_studies}></img>
                        <p>Case Studies</p>
                    </div>
                </div> */}

        <div className={Styles.clients}>
          <div>
            <p className={Styles.cleints_text}>Our Esteemed Clientele</p>
            <p>Join our winning team of satisfied clients</p>
          </div>

          <OurClients />
        </div>
        <div className={Styles.programming_language_text}>
          <p className={Styles.programming_language_text_p}>
            Latest Technologies
          </p>
          <p>Empower your business with cutting-edge tech. </p>
        </div>
        <div className={Styles.programming_language}>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg1}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg2}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg3}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg4}></img>
          </div>
        </div>
        <div className={Styles.programming_language}>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg5}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg6}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg7}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg8}></img>
          </div>
        </div>
        <div className={Styles.programming_language}>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg9}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg10}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg11}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg12}></img>
          </div>
        </div>
        <div className={Styles.programming_language}>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg13}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg14}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg15}></img>
          </div>
          <div className={Styles.programming_language_img}>
            <img src={programmingimg16}></img>
          </div>
        </div>
      </div>
      <button className={Styles.scrollTop} onClick={scrollToTop}>
        Scroll Top
      </button>
    </section>
  );
}
export default WebAndMobileApplication;
